import Vue from 'vue';

Vue.component('cyberster-model-specs-component', {
    props: {
        modelSpecs: {
            type: Array,
            required: true,
        },
        allSpecs: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            specificationCategories: [],
            selectedCategory: this.modelSpecs[0].category,
            selectedSpecification: this.modelSpecs[0],
            areSpecsVisible: false,

            selectedSpecs: null,
            selectedConfigurationTitle: null,
            selectedConfiguration: null,
            specsSelectedModelName: null,
            selectedSpecsModelType: null,
            selectedSpecsModelSublineAsset: null,
            selectedSpecsModelSubline: null,
            selectedSpecsDisclaimer: null,
        };
    },

    mounted() {
        this.getSpecificationCategories();
    },

    methods: {
        parseImage(image) {
            return JSON.parse(image);
        },

        getSpecificationCategories() {
            this.specificationCategories = this.modelSpecs.map(
                (specification) => specification.category,
            );
        },

        selectModelSpecification(passedCategory) {
            this.selectedCategory = passedCategory;
            this.selectedSpecification = this.modelSpecs.find(
                (specification) => specification.category === passedCategory,
            );
        },

        handleSelectedButtonClass(specificationCategory) {
            return this.selectedCategory === specificationCategory
                ? 'cyberster-model-specs__specs__button--selected'
                : '';
        },

        openSpecs() {
            this.areSpecsVisible = true;
            this.selectedSpecs = this.allSpecs;
            this.selectedConfigurationTitle = this.allSpecs.values[0].title;
            this.selectedConfiguration = this.getSelectedConfiguration(
                this.allSpecs.values[0].title,
            );
            this.specsSelectedModelName = 'MG Cyberster';
            this.selectedSpecsModelType = '';
            this.selectedSpecsModelSubline = '';
            this.selectedSpecsModelSublineAsset = null;

            document.body.style.overflow = 'hidden';
        },

        getSelectedConfiguration(configuration) {
            const selectedConfiguration = this.allSpecs.values.find(
                (configValue) => configValue.title === configuration,
            );
            if (!selectedConfiguration) return null;
            this.selectedSpecsDisclaimer = selectedConfiguration.disclaimer;

            const { editions, values } = selectedConfiguration;

            const filteredEditions = editions.filter(
                (edition) => !edition.isDisabled,
            );

            if ('colorTitle' in values[0]) {
                const tableTitle = [
                    { title: values[0].title },
                    ...filteredEditions.map((edition) => ({
                        title: edition.name || '',
                        subtitle: edition.subtitle,
                    })),
                ];
                const parsedColorValues = values.map((value) => [
                    {
                        colorTitle: value?.colorTitle,
                        colorImage: value.image?.url,
                    },
                    ...this.parseValues(value.values[0]),
                ]);
                return [{ tableTitle, tableData: parsedColorValues }];
            }
            const tableData = values.map((value) => ({
                tableTitle: [
                    { title: value.title },
                    ...filteredEditions.map((edition) => ({
                        title: edition.name,
                        subtitle: edition.subtitle,
                    })),
                ],
                tableData: value.values,
            }));

            return tableData;
        },

        parseValues(values) {
            if (Array.isArray(values)) return values;
            if (typeof values === 'object') {
                return Object.values(values);
            }
            return [];
        },

        closeSpecs() {
            this.areSpecsVisible = false;
            document.body.style.overflow = 'auto';
        },

        selectConfiguration(configuration) {
            this.selectedConfigurationTitle = configuration;
            this.selectedConfiguration =
                this.getSelectedConfiguration(configuration);
        },

        isFirstTitle(index) {
            return index === 0
                ? 'new-model-specs__table__header__title--first'
                : '';
        },

        isFirstDataItem(index) {
            return index === 0
                ? 'new-compare-block__table-data__item--first'
                : '';
        },

        isSelectedConfiguration(configuration) {
            return this.selectedConfigurationTitle === configuration
                ? 'new-model-specs__sidebar__selector--light-active'
                : '';
        },

        checkItemsLength(selectedConfiguration) {
            return selectedConfiguration[0].tableTitle.length <= 3
                ? ''
                : 'new-model-specs__table-container--horizontal-scroll';
        },
    },
});
